// Captura fiscal del carrito (boleta/factura + DNI/RUC) — JusChiri.
//
// Vive en assets/ y NO dentro del snippet a proposito. El cajon del carrito se
// re-inyecta con la Section Rendering API + morph, y un <script> que llega por esa
// via NUNCA se ejecuta (los nodos vienen de un DOMParser inerte, ya marcados como
// "iniciados"). Como el snippet solo se renderiza con el carrito lleno, en el
// camino normal —entrar con el carrito vacio, anadir un producto, abrir el cajon—
// el script no llegaba a correr jamas: se veia el bloque y detras no habia nada.
// Cargado desde layout/theme.liquid, el parser lo ejecuta en todas las paginas.

(() => {
  if (window.__juschiriComprobante) return;
  window.__juschiriComprobante = true;

  // Puerto exacto de _valid_ruc (order_processor/app.py): prefijo conocido y
  // digito verificador modulo 11. Que el numero este bien formado NO prueba que
  // el RUC exista en SUNAT: eso el backend tampoco lo comprueba.
  const rucValido = (ruc) => {
    if (!/^(10|15|16|17|20)\d{9}$/.test(ruc)) return false;
    const factores = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    let total = 0;
    for (let i = 0; i < 10; i += 1) total += Number(ruc[i]) * factores[i];
    return (11 - (total % 11)) % 10 === Number(ruc[10]);
  };

  let sucio = false;
  let temporizador = null;
  let enVuelo = null;

  const enviar = (atributos) => {
    sucio = false;
    enVuelo = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: atributos }),
      // keepalive: si el comprador navega al checkout con el POST en vuelo, el
      // navegador lo aborta y el dato se pierde. Con esto lo termina igual.
      keepalive: true,
    }).catch(() => {});
    return enVuelo;
  };

  let ultimos = null;
  const guardar = (atributos, inmediato) => {
    ultimos = atributos;
    sucio = true;
    clearTimeout(temporizador);
    if (inmediato) return enviar(atributos);
    temporizador = setTimeout(() => enviar(ultimos), 400);
    return null;
  };

  // Vacia lo pendiente antes de salir al checkout. Sin esto, escribir el
  // documento y pulsar Pagar dentro de los 400 ms perdia el dato.
  const vaciar = () => {
    clearTimeout(temporizador);
    if (sucio && ultimos) enviar(ultimos);
    return enVuelo || Promise.resolve();
  };

  const leer = (raiz) => {
    const marcado = raiz.querySelector('input[name="attributes[tipo_comprobante]"]:checked');
    const esFactura = marcado?.value === 'factura';
    const docInput = raiz.querySelector('[data-comprobante-documento]');
    const razonInput = raiz.querySelector('[data-comprobante-razon]');
    return {
      esFactura,
      docInput,
      razonInput,
      doc: (docInput?.value || '').replace(/\D/g, ''),
      razon: (razonInput?.value || '').trim(),
      exigeDoc: raiz.dataset.exigeDoc === 'true',
    };
  };

  // Un unico sitio decide que esta mal: lo usan el aviso y el bloqueo del pago.
  const evaluar = (e) => {
    if (e.esFactura) {
      if (e.doc.length !== 11) {
        return { ok: false, aviso: 'La factura necesita un RUC de 11 dígitos.', duro: e.doc.length > 0 };
      }
      if (!rucValido(e.doc)) {
        return { ok: false, aviso: 'Ese RUC no es válido. Revísalo.', duro: true };
      }
      if (!e.razon) {
        return { ok: false, aviso: 'Falta la razón social de la factura.', duro: true };
      }
      return { ok: true, aviso: 'Se emitirá factura a nombre de la razón social.' };
    }
    if (e.doc.length === 0) {
      return e.exigeDoc
        ? { ok: false, aviso: 'Por el monto de la compra, la boleta necesita tu DNI.', duro: true }
        : { ok: true, aviso: 'Opcional. Sin DNI se emite una boleta genérica.' };
    }
    if (e.doc.length !== 8) {
      return { ok: false, aviso: 'El DNI tiene 8 dígitos.', duro: true };
    }
    return { ok: true, aviso: 'Se emitirá boleta a tu nombre.' };
  };

  // `guardando` en false = solo pinta, no toca el carrito. Se usa al enganchar:
  // guardar en ese momento hacia que una pestana vieja pisara con su campo vacio
  // el documento que la otra acababa de escribir.
  const refrescar = (raiz, inmediato, guardando = true) => {
    const e = leer(raiz);
    if (!e.docInput) return { ok: true };

    const razonCampo = raiz.querySelector('[data-comprobante-razon-social]');
    if (razonCampo) razonCampo.hidden = !e.esFactura;
    e.docInput.placeholder = e.esFactura ? 'RUC (11 dígitos)' : 'DNI (8 dígitos)';
    const limpio = e.doc.slice(0, e.esFactura ? 11 : 8);
    if (e.docInput.value !== limpio) e.docInput.value = limpio;

    const estado = evaluar({ ...e, doc: limpio });
    const aviso = raiz.querySelector('[data-comprobante-aviso]');
    if (aviso && aviso.textContent !== (estado.aviso || '')) {
      aviso.textContent = estado.aviso || '';
    }
    if (aviso) aviso.classList.toggle('comprobante__aviso--error', Boolean(estado.duro));
    e.docInput.setAttribute('aria-invalid', estado.duro ? 'true' : 'false');

    if (guardando) {
      guardar({
        // Vacio y no 'boleta' a proposito: con 'boleta' el backend DESCARTA un
        // RUC de 11 digitos (app.py:346) y emite generica. Vacio deja que decida
        // por el documento, que es el comportamiento indulgente si el JS fallara.
        tipo_comprobante: e.esFactura ? 'factura' : '',
        documento: limpio,
        razon_social: e.esFactura ? e.razon : '',
      }, inmediato);
    }

    return estado;
  };

  const raizActiva = () => document.querySelector('[data-comprobante]');

  // Bloqueo del pago. Solo cuando el dato es de verdad incorrecto: una boleta sin
  // DNI por debajo de S/700 pasa sin fricción.
  let reenviando = false;
  const interceptar = (evento, boton) => {
    if (reenviando) return;
    const raiz = raizActiva();
    if (!raiz) return;
    const estado = refrescar(raiz, true);
    if (!estado.ok) {
      evento.preventDefault();
      evento.stopPropagation();
      raiz.querySelector('[data-comprobante-documento]')?.focus();
      return;
    }
    if (sucio || enVuelo) {
      evento.preventDefault();
      evento.stopPropagation();
      vaciar().then(() => {
        reenviando = true;
        if (boton) boton.click();
        else document.getElementById('cart-form')?.requestSubmit?.();
        setTimeout(() => { reenviando = false; }, 2000);
      });
    }
  };

  document.addEventListener('click', (evento) => {
    const boton = evento.target?.closest?.('#checkout, [name="checkout"]');
    if (boton) interceptar(evento, boton);
  }, true);

  document.addEventListener('submit', (evento) => {
    if (evento.target?.id === 'cart-form') interceptar(evento, null);
  }, true);

  // Delegacion en document ADEMAS de los listeners por nodo: si el morph del
  // carrito reemplazara el nodo raiz, la delegacion sigue funcionando sin esperar
  // a que el MutationObserver vuelva a enganchar.
  document.addEventListener('input', (evento) => {
    const raiz = evento.target?.closest?.('[data-comprobante]');
    if (raiz) refrescar(raiz, false);
  });
  document.addEventListener('change', (evento) => {
    const raiz = evento.target?.closest?.('[data-comprobante]');
    if (raiz) refrescar(raiz, true);
  });

  const enganchados = new WeakSet();
  const enganchar = (raiz) => {
    if (!enganchados.has(raiz)) {
      enganchados.add(raiz);
      // focusout guarda ya: es lo que salva a los botones de pago acelerado del
      // carrito, que no envian el formulario ni pasan por el bloqueo.
      raiz.addEventListener('focusout', () => refrescar(raiz, true));
    }
    // Se repinta en cada pasada (sin guardar) para restaurar el aviso y el
    // estado visual que el morph deja en blanco.
    refrescar(raiz, false, false);
  };

  const revisar = () => document.querySelectorAll('[data-comprobante]').forEach(enganchar);

  // El carrito se re-renderiza al cambiar cantidades y al abrir el cajon, asi que
  // no basta con enganchar una vez.
  new MutationObserver(revisar).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revisar);
  } else {
    revisar();
  }
})();
